import {Component, Renderer2} from '@angular/core';
import {BaseComponent} from '../../base/base.component';
import {NavigationService} from '../../base/navigation/navigation.service';
import {Router} from '@angular/router';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-kz-layout',
  templateUrl: './kz-layout.component.html'
})
export class KzLayoutComponent extends BaseComponent {
  tariffs = [
    {
      title: 'Эко',
      speed: 'до 15',
      measure: 'км/час',
      price: '20',
      currency: '₸/мин',
    },
    {
      title: 'Драйв',
      speed: 'до 20',
      measure: 'км/час',
      price: '25',
      currency: '₸/мин',
    },
    {
      title: 'Спорт',
      speed: 'до 25',
      measure: 'км/час',
      price: '30',
      currency: '₸/мин',
    },
    {
      title: 'Час',
      speed: '',
      measure: '',
      price: '1250',
      currency: '₸',
    },
  ];

  constructor(
    public navigationService: NavigationService,
    public renderer: Renderer2,
    protected router: Router,
    private titleService: Title) {
    super(navigationService, router, renderer);
    this.titleService.setTitle('BusyFly - аренда самокатов и велосипедов в твоем городе');
  }
}
